/* SAMPLES:
//////////////////////////////////////////////////////////////////////////////////////////////
//Minimum usable sample:

    UI.message.show({
        header: 'header text',
        body: messageBodyDraw
    });

    UI.message.hide();

//////////////////////////////////////////////////////////////////////////////////////////////
*/
import { PopUp } from "../PopUp";
const UI = window["UI"] || {};
export class UIMessage {
    constructor() {
        this.popupStack = [];
    }
    /**
     * Show specific UI message on screen with passed config
     * @param {UIMessageConfig} config UI message configuration
     * @param {string} id UI message id to show
     */
    show(config, id) {
        const msgStackContainer = document.getElementById("rj-popup-message-root") || document.body;
        const popupInfo = id ? this.popupStack.find(p => p.id === id && typeof id === "string") : undefined;
        let popup;
        if (!popupInfo) {
            popup = new PopUp(config, msgStackContainer, this.removeFromStack.bind(this, id));
            this.popupStack.push({ id, popup });
        }
        else {
            popup = popupInfo.popup;
        }
        popup.show();
        this.popupStack.forEach(p => { p.popup.msgContainer.classList.add("hidden"); });
        popup.msgContainer.classList.remove("hidden");
        return popup;
    }
    /**
     * Hide UI message with specific id if present or the last one
     * @param {string} id UI message id to hide
     */
    hide(id) {
        const popupInfo = id
            ? this.popupStack.find(p => p.id === id && typeof id === "string")
            : this.popupStack[this.popupStack.length - 1];
        if (popupInfo) {
            popupInfo.popup.hide();
        }
        return this.popupStack;
    }
    /**
     * Remove UI message with specific id or the last one.
     * @param {string} id UI message id to remove
     */
    removeFromStack(id) {
        if (this.popupStack.length === 0) {
            return this.popupStack;
        }
        const popupInfoIndex = id ? this.popupStack.findIndex((i) => i.id === id && typeof id === "string") : -1;
        if (popupInfoIndex > -1) {
            let popupToRemove = Object.assign({}, this.popupStack[popupInfoIndex]);
            this.popupStack.splice(popupInfoIndex, 1);
            this.popupStack.push(popupToRemove);
        }
        this.popupStack[this.popupStack.length - 1].popup.msgStackContainer.removeChild(this.popupStack[this.popupStack.length - 1].popup.msgContainer);
        this.popupStack.pop();
        this.popupStack.length > 0 && this.popupStack[this.popupStack.length - 1].popup.msgContainer.classList.remove("hidden");
        return this.popupStack;
    }
}
UI["message"] = new UIMessage();
// override default alert function to use UI.message.show behavior
function alert(message) {
    "use strict";
    UI.message.show({
        body: message,
        actions: {
            cancel: { text: "OK", focus: true },
        }
    });
}
Window.prototype.alert = window.alert = alert;
export const ui = UI;
window["UI"] = UI;
//# sourceMappingURL=UIMessage.js.map